import AddressLoading from './AddressLoading';

export default AddressLoading;
